









import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class Header extends Vue {
  @Getter logoFullUrl!: string;
}
